import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5340e9bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "content-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = {
  class: "sign-key-form",
  id: "sign-key-form"
}
const _hoisted_6 = { class: "fields" }
const _hoisted_7 = { for: "CAList" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("select", {
  name: "CAList",
  id: "CAList"
}, null, -1))
const _hoisted_9 = { class: "fields" }
const _hoisted_10 = { for: "sign-file" }
const _hoisted_11 = { class: "file-input-wrapper" }
const _hoisted_12 = {
  type: "file",
  id: "sign-file",
  accept: ".jks, .pfx, .pk8, .zs2, .dat",
  required: "",
  ref: "signFileInput"
}
const _hoisted_13 = { class: "fields" }
const _hoisted_14 = { for: "sign-password" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-key hide" }, null, -1))
const _hoisted_17 = {
  id: "file-sign-form",
  class: "hide"
}
const _hoisted_18 = {
  key: 0,
  class: "fields"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "file-list-modal"
}
const _hoisted_21 = { class: "file-list-modal--wrapper" }
const _hoisted_22 = { class: "file-list" }
const _hoisted_23 = {
  key: 0,
  class: "status-signed"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "status-nosigned"
}
const _hoisted_26 = {
  key: 0,
  class: "video file-list"
}
const _hoisted_27 = {
  key: 0,
  class: "photo-preview"
}
const _hoisted_28 = {
  class: "video-preview",
  controls: ""
}
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_31 = {
  key: 0,
  class: "status-signed"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 2,
  class: "status-nosigned"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSignKeySubmit && _ctx.onSignKeySubmit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("files.ca")), 1),
                    _hoisted_8
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("files.key")) + " (" + _toDisplayString(_ctx.$t("files.keyTypes")) + ") ", 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("input", _hoisted_12, null, 512)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("files.labelPwd")), 1),
                    _createElementVNode("input", {
                      type: "password",
                      id: "sign-password",
                      required: "",
                      ref: "password",
                      placeholder: _ctx.$t('files.keyPwd')
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["fields", { actions_btns: _ctx.isAdmin }])
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSignReadClick && _ctx.onSignReadClick(...args))),
                      id: "sign-read"
                    }, _toDisplayString(_ctx.$t("files.keyRead")), 1),
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "fields__close-btn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('hideSign')))
                        }, _toDisplayString(_ctx.$t("files.btn_close")), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 32),
                _hoisted_16
              ]),
              _createElementVNode("form", _hoisted_17, [
                (!_ctx.allFileSigned)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t("files.sign_title_for_admin")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileSignClick && _ctx.onFileSignClick(...args)))
                      }, _toDisplayString(_ctx.$t("files.sign")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.fileListModalVisible && !_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photo, (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "file-item"
                  }, [
                    _createElementVNode("span", null, [
                      (!_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "photo-preview",
                            style: _normalizeStyle({'background-image' : `url('${file.base64}')`})
                          }, null, 4))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(file.name), 1)
                    ]),
                    (file.signed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t("files.signed")), 1))
                      : (file.inProgress)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t("files.inProgress")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("files.nSigned")), 1))
                  ]))
                }), 128))
              ]),
              (_ctx.video.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.video, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "file-item"
                      }, [
                        _createElementVNode("span", null, [
                          (!_ctx.isAdmin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("video", _hoisted_28, [
                                  _createElementVNode("source", {
                                    src: file.base64,
                                    type: "video/webm"
                                  }, null, 8, _hoisted_29),
                                  _hoisted_30
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(file.name), 1)
                        ]),
                        (file.signed)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t("files.signed")), 1))
                          : (file.inProgress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t("files.inProgress")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t("files.nSigned")), 1))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}